import { createSlice } from "@reduxjs/toolkit";

const loadInitialState = () => {
  const persistedState = localStorage.getItem("txtconnect_ng_admin") || null;
  const token = localStorage.getItem("txtconnect_ng_admin_token") || null;
  return persistedState
    ? {
        ...JSON.parse(persistedState),
        token: token,
      }
    : {
        txtconnect_ng_admin: null,
        token: null,
      };
};

export const adminSlice = createSlice({
  name: "txtconnect_ng_admin",
  initialState: loadInitialState(),
  reducers: {
    setAdmin: (state, action) => {
      const { adminData, token } = action.payload;
      state.txtconnect_ng_admin = adminData;
      state.token = token;
      localStorage.setItem(
        "txtconnect_ng_admin",
        JSON.stringify({
          txtconnect_ng_admin: adminData,
          token: token,
        })
      );
      if (token) {
        localStorage.setItem("txtconnect_ng_admin_token", token);
      }
    },
    logoutAdmin: (state) => {
      state.txtconnect_ng_admin = null;
      state.token = null;
      localStorage.removeItem("txtconnect_ng_admin");
      localStorage.removeItem("txtconnect_ng_admin_token");
    },
  },
});

export const { setAdmin, logoutAdmin } = adminSlice.actions;
export default adminSlice.reducer;
